export default __webpack_public_path__ + "static/media/Jeremy_Moss.31aa49ce.jpg";